$(() => {
  $('.select-month').select2({
    placeholder: 'Select Month',
    minimumResultsForSearch: Infinity
  });
  $('.select-year').select2({
    placeholder: 'Select Year',
    minimumResultsForSearch: Infinity
  });

  $('#account-type').select2({
    placeholder: 'Select Account Type',
    minimumResultsForSearch: Infinity
  });

  checkPaymentType($('input[name="payCheckbox"]').val());

  $('#invoiceSearchForm .btn-search').click(function () {
    $(this).button('loading');
    $('#invoiceSearchForm input').attr('readonly', true);
  });

  $('#payment #submit').click(function () {
    const btn = $(this);
    $('.help-block').remove();
    $('#payment .form-group').removeClass('has-error');

    const dataArr = $('#payment').serializeArray();

    btn.loading();
    $('#achpayment input, #achpayment select, #payment input, #payment select').loading();

    $.post(urlPayInvoice, {
      dataArr
    }).success((data) => {
      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');

        if (data.formErrorMessagess !== undefined && data.formErrorMessagess.length !== 0) {
          $.each(data.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              $('#payment').find(`[name="${elementId}"]`).parent().addClass('has-error');
              $('#payment').find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        $('section.invoice-details').fadeOut('slow', () => {
          $('form#invoiceSearchForm').animate({ scrollTop: 0 }, 'fast');

          $('section.invoice-details').html(`<p class="bg-success" style="margin-top: 15px; padding: 15px;">Thank you for paying Invoice #${data.idInvoice}. Receipt has been emailed to the account owner and billing contacts.</p>`);
          $('section.invoice-details').fadeIn('slow');
        });
      }
    }).always(() => {
      btn.loading('reset');
      $('#achpayment input, #achpayment select, #payment input, #payment select').loading('reset');
    });

    return false;
  });

  $('#achpayment #submit').click(function () {
    const btn = $(this);
    $('.help-block').remove();
    $('#payment .form-group').removeClass('has-error');

    btn.hide();
    btn.parent().find('.gif-loader').show();
    $('#achpayment input, #achpayment select, #payment input, #payment select').attr('readonly', true);

    const dataArr = $('#achpayment').serializeArray();

    $.post(urlPayInvoice, {
      dataArr
    }, (data) => {
      btn.parent().find('.gif-loader').hide();
      btn.show();
      $('#achpayment input, #achpayment select, #payment input, #payment select').prop('readonly', false);

      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');

        if (data.formErrorMessagess.length !== 0) {
          $.each(data.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              $('#achpayment').find(`[name="${elementId}"]`).parent().addClass('has-error');
              $('#achpayment').find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        $('section.invoice-details').fadeOut('slow', () => {
          $('form#invoiceSearchForm').animate({ scrollTop: 0 }, 'fast');

          $('section.invoice-details').html(`<p class="bg-success" style="margin-top: 15px; padding: 15px;">Thank you for paying Invoice #${data.idInvoice}. Receipt has been emailed to the account owner and billing contacts.</p>`);
          $('section.invoice-details').fadeIn('slow');
        });
      }
    }, 'json');

    return false;
  });

  $('#payVisa, #payACH').on('click', function () {
    checkPaymentType($(this).val());
  });


  function checkPaymentType(value) {
    if (value === 'payVisa') {
      $('#payment').addClass('visible');
      $('#achpayment').removeClass('visible');
      $('#payment').css('display', 'block');
      $('#achpayment').css('display', 'none');
    } else {
      $('#payment').removeClass('visible');
      $('#achpayment').addClass('visible');
      $('#payment').css('display', 'none');
      $('#achpayment').css('display', 'block');
    }
  }
});
